import { useMemo } from 'react';
import { Line } from 'react-chartjs-2';

import { chatChartBaseOptions } from './chatChartOptions';
import { getDatasetColors, VisualizationLineChart } from './visualizationTypes';

type ChatVisualizationLineChartProps = {
  visualization: VisualizationLineChart;
};

export default function ChatVisualizationLineChart({
  visualization,
}: ChatVisualizationLineChartProps) {
  const colors = getDatasetColors(visualization.datasets.length);
  const chartData = useMemo(
    () => ({
      labels: visualization.labels,
      datasets: visualization.datasets.map((dataset, index) => ({
        label: dataset.label,
        data: dataset.data,
        borderColor: colors[index],
        backgroundColor: `${colors[index]}14`,
        borderWidth: 3,
        pointRadius: 4,
        pointHoverRadius: 6,
        pointBackgroundColor: '#FFFFFF',
        pointBorderColor: colors[index],
        pointBorderWidth: 2,
        tension: 0.2,
        fill: visualization.datasets.length === 1,
        datalabels: {
          anchor: 'center' as const,
          align: index % 2 === 0 ? ('top' as const) : ('bottom' as const),
          offset: 1,
          clamp: true,
          clip: false,
          color: colors[index],
          font: {
            size: 9,
            weight: 'bold' as const,
          },
        },
      })),
    }),
    [colors, visualization.datasets, visualization.labels],
  );

  return (
    <div className="h-72 w-full px-4 py-3">
      <Line data={chartData} options={chatChartBaseOptions} />
    </div>
  );
}
